import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { numberToDollars } from '../../utils/numberToCurrency'

export interface TransferDetailsSectionProps {
  transferAmount: number
  fromAccount?: string
  isTotalAmount: boolean
  transferType: string
}

const TransferDetailsSection = ({
  transferAmount,
  fromAccount = '',
  isTotalAmount,
  transferType
}: TransferDetailsSectionProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Transfer Details
      </Text>
      <Stack spacing={4}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='transferType'>
            <Text fontWeight='bold'>Transfer Type</Text>
            <Text>{transferType}</Text>
          </Box>
          <Box w='50%' data-testid='transferAmount'>
            <Text fontWeight='bold'>Transfer Amount</Text>
            <Text>{isTotalAmount ? 'Total Balance' : `${numberToDollars(transferAmount)} (USD)`}</Text>
          </Box>
        </Stack>
        <Stack direction='row' w='100%'>
          <Box w='50%' data-testid='fromAccount'>
            <Text fontWeight='bold'>From Account</Text>
            <Text>{fromAccount}</Text>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default TransferDetailsSection
